import AbstractEntity from "../AbstractEntity";

export default class QualityInspection extends AbstractEntity {
    static STEP_INITIALIZED = 0;
    static STEP_APPOINTMENT = 1;
    static STEP_TRAVEL = 2;
    static STEP_PICTURE_BEFORE = 3;
    static STEP_QUOTATION = 4;
    static STEP_CLIENT_SIGNATURE = 5;
    static STEP_WORK = 6;
    static STEP_PICTURE_AFTER = 7;
    static STEP_DELIVERY = 8;

    static SUB_STEP_DEFAULT = -1;

    static SUB_STEP_ALL_TO_VALIDATE = 0;
    static SUB_STEP_ALL_VALIDATED = 1;
    static SUB_STEP_ALL_SIGNATURE = 2;
    static SUB_STEP_ALL_PAYMENT = 3;

    static APPOINTMENT_PLANNING_INITIATOR_BENEFICIARY = 0;
    static APPOINTMENT_PLANNING_INITIATOR_COMPANY = 1;

    _id;
    _currentStep;
    _currentSubStep;
    _completedWorks;
    _deliveredWithoutReservation;
    _deliveredComment;
    _quotationValidate;
    _waitingPrescriberValidation;
    _arrivedAt;
    _leftAt;
    _presenceDetected;
    _appointmentAt;
    _travelAt;
    _pictureBeforeAt;
    _quotationAt;
    _clientSignatureAt;
    _workAt;
    _pictureAfterAt;
    _deliveryAt;
    _quotationValidateAt;
    _clientContactedByCompany;
    _clientNotReply
    _nextOrderId;
    _interventionId;


    getId() {
        return this._id;
    }

    getCurrentStep() {
        return this._currentStep;
    }

    getCurrentSubStep() {
        return this._currentSubStep;
    }

    getCompletedWorks() {
        return this._completedWorks;
    }

    isDeliveredWithoutReservation() {
        return this._deliveredWithoutReservation;
    }

    getDeliveredComment() {
        return this._deliveredComment;
    }

    isQuotationValidate() {
        return this._quotationValidate;
    }

    isWaitingPrescriberValidation() {
        return this._waitingPrescriberValidation;
    }

    getArrivedAt() {
        return this._arrivedAt;
    }

    getLeftAt() {
        return this._leftAt;
    }

    isPresenceDetected() {
        return this._presenceDetected;
    }

    getAppointmentAt() {
        return this._appointmentAt;
    }

    getTravelAt() {
        return this._travelAt;
    }

    getPictureBeforeAt() {
        return this._pictureBeforeAt;
    }

    getQuotationAt() {
        return this._quotationAt;
    }

    getClientSignatureAt() {
        return this._clientSignatureAt;
    }

    getWorkAt() {
        return this._workAt;
    }

    getPictureAfterAt() {
        return this._pictureAfterAt;
    }

    getDeliveryAt() {
        return this._deliveryAt;
    }

    getQuotationValidateAt() {
        return this._quotationValidateAt;
    }

    isClientContactedByCompany() {
        return this._clientContactedByCompany;
    }

    isClientNotReply() {
        return this._clientNotReply;
    }

    getNextOrderId() {
        return this._nextOrderId;
    }

    getInterventionId() {
        return this._interventionId;
    }

    getClassName() {
        return "quality_inspection"
    }
}